// extracted by css-extract-rspack-plugin
export default {"link":"link-eVW0W1","unavailable":"unavailable-MNGtge"};